export const AUTH_CLIENT_ID: string = 'angular';
export const AUTH_DUMMY_CLIENT_SECRET: string = 'bff_b2bweb_secret_814';
export const AUTH_RESPONSE_TYPE: string = 'code';
export const AUTH_SCOPE: string = 'openid bff_b2bweb_api offline_access';
